<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Sigla" v-model="form.sigla" :value="form.sigla"></input-form-text>
					<input-form-text textInput="Secretaria" :required="true" v-model="form.titulo" :value="form.titulo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Foto secretaria</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages.length" ref="fupload" :url="'/v1/secretarias/upload'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImages"
								url="/v1/secretarias/upload" id="id"></items-edit>
						</div>
					</div>
					<input-form-text textInput="Secretário(a)" v-model="form.nome" :value="form.nome"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Foto secretario(a)</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImagesPessoa.length" ref="fuploadPessoa" :url="'/v1/secretarias/upload/pessoa'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImagesPessoa"
								url="/v1/secretarias/upload/pessoa" id="id"></items-edit>
						</div>
					</div>
					<input-form-text textInput="Horário" v-model="form.horario" :value="form.horario"></input-form-text>
					<input-form-text textInput="Telefone" v-model="form.telefone" :value="form.telefone"></input-form-text>
					<input-form-text textInput="E-mail" v-model="form.email" :value="form.email"></input-form-text>
					<input-form-text textInput="Endereço" v-model="form.endereco" :value="form.endereco"></input-form-text>
					<input-form-text textInput="Coordenada" v-model="form.coordenada" :value="form.coordenada"></input-form-text>
					<div v-if="$route.params.id == 1">
						<input-form-text textInput="Vice-Prefeito" v-model="form.nome_vice" :value="form.nome_vice"></input-form-text>
						<div class="form-group">
							<label class="col-sm-3 control-label no-padding-right">Foto Vice-Prefeito</label>
							<div class="col-sm-5">
								<file-upload v-if="!allImagesVice.length" ref="fuploadVice" :url="'/v1/secretarias/upload/vice'" :id="null"
									:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
								<items-edit v-else :files="allImagesVice"
									url="/v1/secretarias/upload/vice" id="id"></items-edit>
							</div>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Principal</label>
						<div class="col-sm-9">
							<editor v-model="form.principal" style="height: 280px">
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Competencia</label>
						<div class="col-sm-9">
							<editor v-model="form.competencia" style="height: 280px">
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Estrutura</label>
						<div class="col-sm-9">
							<editor v-model="form.estrutura" style="height: 280px">
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Profissionais</label>
						<div class="col-sm-9">
							<editor v-model="form.profissionais" style="height: 280px">
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Fluxograma</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImagesFluxo.length" ref="fuploadFluxo" :url="'/v1/secretarias/upload/fluxograma'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImagesFluxo"
								url="/v1/secretarias/upload/fluxograma" id="id"></items-edit>
						</div>
					</div>
					<!-- <div class="form-group">
						<select-form v-model="form.tipo" :value="form.tipo" name="Tipo"
							url="/arquivos?cat=2" id="cod" titulo="nome" layout="true" optionText="Selecione"
							required="false"></select-form>
					</div> -->
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import '@progress/kendo-ui'
import '@progress/kendo-ui/css/web/kendo.default-v2.min.css'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'
import '@progress/kendo-ui/js/messages/kendo.messages.pt-BR'
import { Editor, EditorTool, EditorInstaller } from '@progress/kendo-editor-vue-wrapper'

// eslint-disable-next-line no-undef
kendo.culture('pt-BR')
Vue.use(EditorInstaller)

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
		Editor,
		EditorTool,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Secretarias',
			form: {
				sigla: '',
				titulo: '',
				nome: '',
				horario: '',
				telefone: '',
				email: '',
				endereco: '',
				coordenada: '',
				principal: '',
				competencia: '',
				estrutura: '',
				profissionais: '',
				tipo: '2',
				ativo: '1',
				nome_vice: '',
			},
			allImages: [],
			allImagesPessoa: [],
			allImagesFluxo: [],
			allImagesVice: [],
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			if (this.$route.params.id) {
				let resp = await req(`/v1/secretarias/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				resp.id = this.$route.params.id
				if (!this.allImages.length) {
					this.isActive = false
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				if (!this.allImagesPessoa.length) {
					this.isActive = false
					const tbPessoa = this.$refs.fuploadPessoa.$children.filter(i => i.$refs.tb)
					const mPessoa = tbPessoa[0]
					await mPessoa.uploadAll(resp)
				}
				if (!this.allImagesFluxo.length) {
					this.isActive = false
					const tbFluxo = this.$refs.fuploadFluxo.$children.filter(i => i.$refs.tb)
					const mFluxo = tbFluxo[0]
					await mFluxo.uploadAll(resp)
				}
				if (!this.allImagesVice.length) { // Novo upload
					this.isActive = false
					const tbVice = this.$refs.fuploadVice.$children.filter((i) => i.$refs.tb)
					const mVice = tbVice[0]
					await mVice.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/secretarias')
			} else {
				let resp = await req('/v1/secretarias', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				const tbPessoa = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const mPessoa = tbPessoa[0]
				await mPessoa.uploadAll(resp)
				const tbFluxo = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const mFluxo = tbFluxo[0]
				await mFluxo.uploadAll(resp)
				const tbVice = this.$refs.fuploadVice.$children.filter((i) => i.$refs.tb) // Novo upload
				const mVice = tbVice[0]
				await mVice.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/secretarias')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/secretarias/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.sigla = resp.sigla
			this.form.titulo = resp.titulo
			this.form.nome = resp.nome
			this.form.horario = resp.horario
			this.form.telefone = resp.telefone
			this.form.email = resp.email
			this.form.endereco = resp.endereco
			this.form.coordenada = resp.coordenada
			this.form.principal = resp.principal
			this.form.competencia = resp.competencia
			this.form.estrutura = resp.estrutura
			this.form.profissionais = resp.profissionais
			this.form.tipo = resp.tipo
			this.form.ativo = resp.ativo
			this.form.nome_vice = resp.nome_vice
			this.allImages = resp.foto_secretaria ? [{ id: this.$route.params.id, images: resp.foto_secretaria }] : ''
			this.allImagesPessoa = resp.foto_pessoa ? [{ id: this.$route.params.id, images: resp.foto_pessoa }] : ''
			this.allImagesFluxo = resp.fluxograma ? [{ id: this.$route.params.id, images: resp.fluxograma }] : ''
			this.allImagesVice = resp.foto_vice ? [{ id: this.$route.params.id, images: resp.foto_vice }] : ''
			this.isActive = false

		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
